import React, { Fragment, useEffect, useState } from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../assets/stamp.png";

const borderColor = "#3778C2";
const styles = StyleSheet.create({
  row: {
    marginTop: "24",
    flexDirection: "row",
    borderBottomColor: "#3778C2",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontStyle: "bold",
  },
  description: {
    width: "50%",
    textAlign: "left",
    paddingLeft: 8,
  },
  qty: {
    width: "50%",
    textAlign: "right",
    paddingRight: 8,
    flexDirection: "column",
    alignItems: "flex-end",
  },
  stampContainer: {
    alignItems: "center",
    marginBottom: 0,
    position: "relative",
  },
  stamp: {
    width: 180,
    height: 120,
    position: "absolute",
    top: -85,
  },
  directorText: {
    fontSize: 12,
  },
  rate: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
    paddingRight: 8,
  },
  amount: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
});

const InvoiceTableRow = ({ items, certificateUpdateDate }) => {
  const [date, setDate] = useState("");

  const standerDateFormate = (date) => {
    const toDate = new Date(date);
    const day = String(toDate.getDate()).padStart(2, "0");
    const year = toDate.getFullYear();

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[toDate.getMonth()];
    const formattedDate = `${day} ${month} ${year}`;
    setDate(formattedDate);
  };

  useEffect(() => {
    const dates =
      typeof window !== "undefined"
        ? localStorage.getItem("date") || "N/A"
        : "N/A";
    standerDateFormate(dates);
  }, []);

  return (
    <View style={styles.row}>
      <Text style={styles.description}>Date: {date}</Text>
      
      <View style={styles.qty}>
        <View style={styles.stampContainer}>
          <Image style={styles.stamp} src={logo} />
          <Text style={styles.directorText}>Director & Principal Officer</Text>
        </View>
      </View>
    </View>
  );
};

export default InvoiceTableRow;